export const editorContextKeys = {
  all: ["editor-context"] as const,
  context: () => [...editorContextKeys.all, "context"] as const,
  categories: () => [...editorContextKeys.all, "categories"] as const,
  materials: () => [...editorContextKeys.all, "materials"] as const,
  collections: (storeTemplateId?: string) =>
    [...editorContextKeys.all, "collections", storeTemplateId ?? null] as const,
  products: (params: Record<string, unknown>) =>
    [...editorContextKeys.all, "products", params] as const,
};
